var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5001 1H13.5001C12.4876 1 11.6667 1.82081 11.6667 2.83333V24.1667C11.6667 25.1792 12.4876 26 13.5001 26C14.5126 26 15.3334 25.1792 15.3334 24.1667V2.83333C15.3334 1.82081 14.5126 1 13.5001 1Z",
    fill: "white",
    stroke: "#101010"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 13.5003V13.5003C26 12.4878 25.1792 11.667 24.1667 11.667H2.83333C1.82081 11.667 1 12.4878 1 13.5003C1 14.5129 1.82081 15.3337 2.83333 15.3337H24.1667C25.1792 15.3337 26 14.5129 26 13.5003Z",
    fill: "white",
    stroke: "#101010"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.a41820f1009f6a45e9890879460dfa57.svg";
export { ForwardRef as ReactComponent };